export function pictureSlider() {
    let initializedClassName = "initialized";

    $(".picture-slider").each(function () {
        let slider = $(this);
        let isPagination = slider.hasClass("with-pagination");

        if (!slider.hasClass(initializedClassName)) {
            let items = slider.find(".picture");

            if (items.length > 1) {
                slider
                    .addClass(initializedClassName)
                    .slick({
                        infinite: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        mobileFirst: true,
                        dots: true,
                        arrows: false,
                        responsive: [
                            {
                                breakpoint: 1200,
                                settings: {
                                    arrows: true,
                                    dots: isPagination,
                                }
                            }
                        ]
                    });
            }
        }
    });
}








// WEBPACK FOOTER //
// ./assets/js/modules/pictureSlider.js